
define(
	'TrackingSO.Shopping.EntryPoint'
,   [
		'TrackingSO.PDP.View',
		'Profile.Model'
	]
,   function (
		TrackingSOPDPView,
		ProfileModel
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var environmentComponent = container.getComponent('Environment');
			var layoutComponent = container.getComponent('Layout');
			var profile = ProfileModel.getInstance();
			var customerId = profile.get('internalid');
			var trackingSOConfiguration = {};
			if (environmentComponent) {
				trackingSOConfiguration = environmentComponent.getConfig('TrackingSO');
			}
			var enableTrackingSO = trackingSOConfiguration.enableTrackingSOAllCustomers || (trackingSOConfiguration.testCustomer == customerId);

			if(enableTrackingSO && layoutComponent){
				layoutComponent.addChildView('Header', function () {
					return new TrackingSOPDPView({
						container: container,
						trackingSOConfiguration: trackingSOConfiguration
					});
				});
			}
		}
	};
});
